import { buildStyledXlsx, flattenAttributes, relationName } from "./helpers";
import type { AssetRow, PropertyRow } from "./types";

export function buildAssetRegisterXlsx(assets: AssetRow[], propertyMap: Map<string, PropertyRow>): ArrayBuffer {
  const rows: string[][] = [[
    "Store",
    "Address",
    "City",
    "State",
    "Category",
    "Name",
    "Description",
    "Manufacturer",
    "Model Name",
    "Model Number",
    "Serial Number",
    "Manufacture Date",
    "Estimated Age (Years)",
    "Condition Status",
    "Location in Store",
    "Attributes",
    "Notes",
    "Nameplate Photo",
    "Asset Photo",
  ]];

  for (const asset of assets) {
    const property = propertyMap.get(asset.property_id);
    rows.push([
      property?.name ?? "",
      property?.address ?? "",
      property?.city ?? "",
      property?.state ?? "",
      relationName(asset.asset_categories),
      asset.name ?? "",
      asset.description ?? "",
      asset.manufacturer ?? "",
      asset.model_name ?? "",
      asset.model_number ?? "",
      asset.serial_number ?? "",
      asset.manufacture_date ?? "",
      asset.estimated_age_years?.toString() ?? "",
      asset.condition_status ?? "",
      relationName(asset.project_zones),
      flattenAttributes(asset.category_attributes),
      asset.notes ?? "",
      asset.nameplate_photo_url ?? "",
      asset.asset_photo_url ?? "",
    ]);
  }

  return buildStyledXlsx(rows, "Asset Register", [22, 32, 18, 12, 22, 28, 36, 20, 20, 20, 20, 16, 14, 16, 20, 44, 44, 56, 56]);
}
